import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroHeader from "./sections/HeroHeader";
import ConferenceDetails from "./sections/ConferenceDetails";
import ConferenceLeads from "./sections/ConferenceLeads";
import ScheduleHighlights from "./sections/ScheduleHighlights";
import CallToActionRegistration from "./sections/CallToActionRegistration";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroHeader />
      <ConferenceDetails />
      <ConferenceLeads />
      <ScheduleHighlights />
      <CallToActionRegistration />
      <Footer />
    </div>;
}